import { render, staticRenderFns } from "./EntryMessage.vue?vue&type=template&id=7ec1fed4"
import script from "./EntryMessage.vue?vue&type=script&lang=js"
export * from "./EntryMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports